import { cookiesManager } from '@/lib/utils/cookiesManager';
import DiscountProvider from '@petplate/ui/components/DiscountProvider';
import { FB_ID_COOKIE } from '@petplate/ui/lib/cookies';
import { ShopifyCartProvider } from '@petplate/ui/providers/ShopifyCartProvider';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { useSiteWideDiscounts } from '../../lib/siteWideDiscounts';
import { AnalyticsProvider } from './AnalyticsProvider';
import { CurrentUserProvider } from './CurrentUserProvider';

export const Providers = () => {
  const [fbIdentifier, setFbIdentifier] = useState<string>();
  const {
    siteWideCoupon,
    siteWideBackupCode,
    subCancelledEntreesDiscount,
    treatsDiscount,
    isLoading
  } = useSiteWideDiscounts();

  useEffect(() => {
    const savedId = cookiesManager.get(FB_ID_COOKIE);
    if (!fbIdentifier && !savedId) {
      const newId = uuid();
      setFbIdentifier(newId);
      cookiesManager.set(FB_ID_COOKIE, newId, { expires: 30 });
    }
  }, []);

  return (
    <AnalyticsProvider>
      <ShopifyCartProvider>
        <DiscountProvider
          loading={isLoading}
          siteWideCoupon={siteWideCoupon}
          siteWideBackupCode={siteWideBackupCode}
          subCancelledEntreesDiscount={subCancelledEntreesDiscount}
          treatsDiscount={treatsDiscount}
        >
          <CurrentUserProvider>
            <Outlet />
          </CurrentUserProvider>
        </DiscountProvider>
      </ShopifyCartProvider>
    </AnalyticsProvider>
  );
};
